import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'
import { SupportedLanguage } from '@/types/config'

export * from './fragments'

export type State = {
  language: string
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onChangeLanguage: (value: SupportedLanguage) => Promise<void>
}

export const LanguageSettingTemplate: Template<State, Action> = ({
  state,
  onChangeLanguage,
}) => {
  const { t } = useTranslation('languageSetting')
  const { routerNames, routerPages } = useRouter()

  return (
    <>
      <Head title={routerNames.LanguageSetting} />
      <BaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.Setting,
          title: t('title'),
        }}
      >
        <LanguageSelectCell
          language={state.language}
          onChangeLanguage={onChangeLanguage}
        />
      </BaseLayout>
    </>
  )
}

type LanguageSelectCellProps = {
  language: State['language']
  onChangeLanguage: Action['onChangeLanguage']
}
const LanguageSelectCell: Cell<LanguageSelectCellProps> = ({
  language,
  onChangeLanguage,
}) => {
  const { t } = useTranslation('languageSetting')
  const languages: { value: SupportedLanguage; label: string }[] = [
    /**
     * @description
     * Open when function is implemented in the future
     */
    // {
    //   value: 'de',
    //   label: t('deLabel'),
    // },
    // {
    //   value: 'en-GB',
    //   label: t('enGBLabel'),
    // },
    {
      value: 'en-US',
      label: t('enUSLabel'),
    },
    // {
    //   value: 'es-ES',
    //   label: t('esESLabel'),
    // },
    // {
    //   value: 'es',
    //   label: t('esLabel'),
    // },
    // {
    //   value: 'fr-FR',
    //   label: t('frFRLabel'),
    // },
    // {
    //   value: 'it-IT',
    //   label: t('itITLabel'),
    // },
    // {
    //   value: 'pt-BR',
    //   label: t('ptBRLabel'),
    // },
    // {
    //   value: 'ru-RU',
    //   label: t('ruRULabel'),
    // },
    {
      value: 'ja-JP',
      label: t('jaJPLabel'),
    },
    // {
    //   value: 'zh-TW',
    //   label: t('zhTWLabel'),
    // },
    // {
    //   value: 'zh-CN',
    //   label: t('zhCNLabel'),
    // },
    // {
    //   value: 'ko-KR',
    //   label: t('koKRLabel'),
    // },
  ]
  return (
    <CellFrame sx={{ px: 5 }}>
      <RadioGroup
        value={language}
        onChange={event =>
          onChangeLanguage(event.target.value as SupportedLanguage)
        }
      >
        {languages.map(({ label, value }) => (
          <FormControlLabel
            value={value}
            key={value}
            control={<Radio />}
            label={label}
          />
        ))}
      </RadioGroup>
    </CellFrame>
  )
}
